// Landings con cotizador simplificado ("te llamamos") para bicicleterías aliadas.
// `utm` es sw_bicicleterias.utm en novedades: el back busca ahí la bicicletería
// y carga el lead con canal 6 (Bicicleterias) vinculado a ella.
export const LANDINGS_ALIANZAS = [
  {
    path: "/bicicleteria-entre-pedales",
    utm: "entre-pedales",
    nombre: "Entre Pedales",
    logo: "/images/alianzas/entre-pedales.png",
  },
];
